import { removeAccents } from '../../../presentation/services/strings';
import {
  ValidateNicknameMessage,
  ValidationStatus,
} from './dtos/ValidationNicknameDTO';
import { NICKNAME_REGEX } from './constants';

const checkLength = (value: string) => value.length >= 2 && value.length <= 35;

const checkPattern = (value: string) =>
  NICKNAME_REGEX.test(removeAccents(value));

const validateNickname = (value: string): ValidateNicknameMessage => {
  const lengthIsValid = checkLength(value);
  const patternIsValid = checkPattern(value);

  if (!lengthIsValid) {
    return {
      type: ValidationStatus.ERROR_LENGTH,
      message: '',
    };
  }

  if (!patternIsValid) {
    return {
      type: ValidationStatus.ERROR_PATTERN,
      message: '',
    };
  }

  return {
    type: ValidationStatus.SUCCESS,
    message: '',
  };
};

export default validateNickname;
